// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

// Material Kit 2 React examples
import HorizontalTeamCard from 'examples/Cards/TeamCards/HorizontalTeamCard';

// Images
import director from 'assets/csdd_images/directorFinal_.png';
import secondDirector from 'assets/csdd_images/secondDirector_.jpg';
import dennis_img from 'assets/csdd_images/dennis_final_final_pic.jpg';

import Newsletter from 'csdd_components/Newsletter';
import Footer from 'csdd_components/Footer';
import TopNavBar from 'csdd_components/TopNavBar';
import HomeNavBar from 'csdd_components/HomeNavBar';

function ExecutiveMembers() {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <MKBox>
        <MKBox
          component='section'
          variant='gradient'
          bgColor='warning'
          position='relative'
          py={6}
          px={{ xs: 2, lg: 0 }}
        >
          <Container>
            <Grid container>
              <Grid item xs={12} md={8} sx={{ mb: 6 }}>
                <MKTypography textGradient variant='h2' color='black'>
                  The Executive Team
                </MKTypography>
                <MKTypography variant='body2' color='light'>
                  Get to know the professionals leading by excellence
                </MKTypography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={6}>
                <MKBox mb={1}>
                  <HorizontalTeamCard
                    image={director}
                    name='Collins Agyemang Sarpong'
                    titles='(FGIPS, MCIPS, MBA, CIPP, MGIM, MCCL)'
                    position={{ color: 'black', label: 'Executive Director' }}
                    description='Collins Agyemang Sarpong is a Chartered Procurement and Supply Chain Management Professional with over 20 years of experience in the field. He has held prominent positions as Head of Procurement and Supply Chain Management across various local and international organizations, including the United Nations Development Programme (UNDP), American Embassy, United Nations High Commissioner for Refugees (UNHCR), Agricultural Development Bank, and Standard Chartered Bank, Ghana & West Africa.'
                    profileLink='/our-board/collins-agyemang-sarpong'
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} lg={6}>
                <MKBox mb={{ xs: 1, lg: 0 }}>
                  <HorizontalTeamCard
                    image={secondDirector}
                    name='Simon Annan'
                    titles=''
                    profileLink='/our-board/simon-annan'
                    position={{ color: 'black', label: 'Director' }}
                    description='Simon Annan is a doctoral student at Cranfield University, UK, and a Fellow of the Chartered Institute of Procurement and Supply (CIPS), UK, Ghana Institute of Procurement and Supply and Institute of Project Management Professionals and a Chartered member of the Institute of Logistics and Transport (CMILT), UK. He also holds an MBA in Strategic and Project Management.'
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox
          component='section'
          variant='gradient'
          bgColor='white'
          position='relative'
          py={6}
          px={{ xs: 2, lg: 0 }}
        >
          <Container>
            <Grid container>
              <Grid item xs={12} md={8} sx={{ mb: 6 }}>
                <MKTypography textGradient variant='h2' color='black'>
                  Management
                </MKTypography>
                <MKTypography variant='body2' color='warning'>
                  Learn about the management team
                </MKTypography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={6}>
                <MKBox mb={1}>
                  <HorizontalTeamCard
                    image={dennis_img}
                    name='Dennis Teye-Adjei'
                    titles=''
                    position={{ color: 'black', label: 'Head - Operations' }}
                    description='With over a decade in Administration and the Finance sector, Dennis Teye-Adjei brings a wealth of experience to our team.'
                    profileLink='/our-board/dennis-teye-adjei'
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </MKBox>
      <Newsletter />
      <Footer />
    </>
  );
}

export default ExecutiveMembers;
